import { render, staticRenderFns } from "./CancelButton.vue?vue&type=template&id=56731212&"
import script from "./CancelButton.vue?vue&type=script&lang=js&"
export * from "./CancelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports